"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationPanel = void 0;

var _styles = require("./styles");

var _acceptIcon = _interopRequireDefault(require("../../../assets/images/generalButton/acceptIcon.svg"));

var _rejectIcon = _interopRequireDefault(require("../../../assets/images/generalButton/rejectIcon.svg"));

var _nullIcon = _interopRequireDefault(require("../../../assets/images/generalButton/nullIcon.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var ValidationPanel = function ValidationPanel(_ref) {
  var id = _ref.id,
      setOptionClicked = _ref.setOptionClicked,
      setShowValidationPanel = _ref.setShowValidationPanel,
      approve = _ref.approve,
      reject = _ref.reject,
      approveAll = _ref.approveAll,
      rejectAll = _ref.rejectAll,
      showApproveRejectAll = _ref.showApproveRejectAll;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: id,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      onClick: function onClick() {
        approve && approve();
      },
      className: "validation-option",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _acceptIcon.default,
        alt: "accept button"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "Validado"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      onClick: function onClick() {
        reject && reject();
      },
      className: "validation-option",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _rejectIcon.default,
        alt: "reject button"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "Rechazado"
      })]
    }), showApproveRejectAll && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: function onClick() {
          approveAll && approveAll();
        },
        className: "validation-option",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _acceptIcon.default,
          alt: "accept button"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Validar todo y enviar a evaluaci\xF3n"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: function onClick() {
          rejectAll && rejectAll();
        },
        className: "validation-option",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _rejectIcon.default,
          alt: "reject button"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Rechazar todo y enviar a evaluaci\xF3n"
        })]
      })]
    })]
  });
};

exports.ValidationPanel = ValidationPanel;